const cache = new Map<string, unknown>();

export const readCache = <TValue>(key: string): TValue | undefined =>
  cache.get(key) as TValue | undefined;

export const writeCache = <TValue>(key: string, value: TValue): void => {
  cache.set(key, value);
};

export const clearCache = (key: string): void => {
  cache.delete(key);
};

export const CACHE_KEYS = {
  accountOverview: 'account:overview',
  accountStats: 'account:stats',
  editProfileSnapshot: 'account:edit-profile',
  editShopSnapshot: 'account:edit-shop',
  myRating: 'account:my-rating',
} as const;
